import { render, staticRenderFns } from "./MainBranchTable.vue?vue&type=template&id=7b058648&scoped=true&"
import script from "./MainBranchTable.vue?vue&type=script&lang=js&"
export * from "./MainBranchTable.vue?vue&type=script&lang=js&"
import style0 from "./MainBranchTable.vue?vue&type=style&index=0&id=7b058648&scoped=true&lang=css&"
import style1 from "./MainBranchTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b058648",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
